(ns pfo.widget.paginator
  (:require
    [reagent.core :as reagent :refer [atom]]
    [dommy.core :as dommy :refer-macros [sel sel1]]
    [dommy.utils]
    [pfo.util :refer [entity classes]]))

(defn paginator
  "OPTS may replace the :prev-label and :next-label words, e.g. with arrows."
  [pages current-page previous-func next-func prev-next-only {:keys [prev-label next-label]}]
  (when-not (and (<= (count pages) 1) (not prev-next-only))
    [:section {:class (classes "c-paginator" "o-margin-elements--medium"
                               (when (or prev-label next-label) "c-paginator--icons"))}

     (when previous-func
       [:a {:href "#" :on-click previous-func} (or prev-label (entity "prev"))])

     (when-not prev-next-only
       (map-indexed (fn [idx {number :number on-click :on-click}]
                      (condp = number
                        current-page [:span.c-paginator__disabled {:key (str "page" idx)} number]
                        0 [:span {:key (str "page" idx)} "..."]
                        [:a {:on-click on-click :href "#"  :key (str "page" idx)} number]))
                    pages))

     (when next-func
       [:a {:href "#" :on-click next-func} (or next-label (entity "next"))])]))

(defn tfoot-paginator [paginator-comp col-span has-more-pages?]
  [:tfoot
   (when has-more-pages?
     [:tr
      [:td.u-text-align-center {:col-span col-span} paginator-comp]])])

(defn load-more [next-func]
    [:section.c-paginator
     [:a {:href "#" :on-click next-func} "more"]])
